import { useContext, useState} from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { ModalManagementStore } from '../../../providers/modal-manager';
import Button from '../../../components/Button';
import GenericCard from '../../../components/GenericCards/GenericCards';
import Pager from '../../../components/Pager';
import Chip from '../../../components/TransactionStatus/Chip';
import Link from '../../../components/Link';

import {
  TransactionHistoryStore,
  TransactionHistoryProvider,
} from '../../../providers/benefitAmounts';

function TableData() {
  const [currPage, setCurrPage] = useState(1);
  const { benefitAmounts } = useContext(TransactionHistoryStore);
  const { openModal } = useContext(ModalManagementStore);

  return (
    <Container className={'cnd-custom-container px-0'}>
      <Container className={'px-7 px-lg-0 mb-10 mb-lg-10'}>
        <Row>
          <Col className={'col-8 col-lg-6'}>
            <h4 className={'text-sm-20-lg-32 m-0 lh-xs'}>
              Benefit Amounts
            </h4>
          </Col>
 
        </Row>
 

      </Container>
      <GenericCard variant={'white'}>
        <Row>
          <Col>
            <Row className={'d-none d-lg-flex border-bottom-dark-gray py-8'}>
              <Col className={' col-auto col-1  col-lg-3 text-fs-6 m-0'}>
                Plan
              </Col>
              <Col className={'col-lg-3 ps-6 m-0'}>
                <span className={'text-fs-6'}>Dates</span>
              </Col>
              <Col className={'col-auto col-1 col-lg-3 text-fs-6 m-0'}>
                <span className={'text-fs-6'}>Form</span>
              </Col>
              <Col className={'col-auto col-lg-3 text-fs-6 m-0'}>
                <span className={'text-fs-6'}>Amount</span>
              </Col>
            </Row>
            {benefitAmounts.map((transaction, index) => {
              return (
                <Row className={'striped-rows-fixed-children px-8 py-11 px-lg-0 py-lg-8 d-flex flex-lg-row flex-wrap align-items-center border-bottom border-info'}
                key={index}>
                  <Col className={'d-flex d-lg-block col-12 col-lg-3 px-3 py-2 order-1'}>
                    
                  <h2
                      className={'d-lg-none col-2 h6 text-fs-6 m-0 pb-lg-8'}
                    >
                      Plan 
                    </h2>
                    <span className={'w-100 col-auto  text-lg-start h3 text-fs-6 m-0'}>
                    {transaction['plan']} 
                    </span>
                  </Col>
                  <Col className={'d-flex d-lg-block col-12 col-lg-3 px-3 py-2 order-1'}>
                  <h2
                      className={'d-lg-none col-2 h6 text-fs-6 m-0 pb-lg-8'}
                    >
                     Date
                    </h2>
                    <span className={'w-100  col-auto text-lg-start h3 text-fs-6 m-0'}>
                      {transaction['date']}
                    </span>
                  </Col>
       
                  <Col className={'d-flex d-lg-block col-12 col-lg-3 px-3 py-2 order-1'}>
                  <h2
                      className={'d-lg-none col-2 h6 text-fs-6 m-0 pb-lg-8'}
                    >
                      Forms
                    </h2>
                    <span className={'w-100  flex-wrap col-auto text-lg-start h3 text-fs-6  '}>
                      {transaction['forms']}
                    </span>
                  </Col>
 
 
                  <Col className={'d-flex d-lg-block align-items-center col-12 col-lg-2 order-5 order-lg-4 py-6 px-5 py-lg-0'}>
                    <h2 className={'d-lg-none col-auto h6 text-fs-6 m-0'}>
                      Amount
                    </h2>
                    <span className={'w-100 text-end text-lg-start h3 text-fs-6 m-0'}>
                      {transaction['amount']}
                    </span>
                  </Col>
                  
                </Row>
              );
            })}
          </Col>
        </Row>
        <Container
          className={
            'px-0 mt-11 d-flex d-lg-block justify-content-center mt-11 mt-lg-10'
          }
        >
           <Button
              variant="primary-outline"
              className={'mx-lg-10 order-3 order-lg-2 mt-7 mt-lg-0'}
               >
              Direct Deposit
            </Button>
            <Button
              variant="primary-outline"
              className={'mx-lg-10 order-3 order-lg-2 mt-7 mt-lg-0'}
               >
              Tax Withholding
            </Button>
        </Container>
      </GenericCard>
    </Container>
  );
}

const benefitAmounts = () => {
  return (
    <TransactionHistoryProvider>
      <TableData />
    </TransactionHistoryProvider>
  );
};

export default benefitAmounts;
